import { useGlobalQueries } from 'app/GlobalQueriesProvider'
import routes from 'app/RootRoutes'
import Loading from 'egret/components/EgretLoadable/Loading'
import { isNil } from 'lodash'
import { FC } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import { renderRoutes } from 'react-router-config'
import { Redirect, useLocation } from 'react-router-dom'
import { FIRST_LOGIN_FLOW_PATHS } from './FirstLoginFlowConstants'
import { firstLoginFlowRoutes } from './firstLoginFlowRoutes'
import FirstLoginFlow from './index'

interface Props {
  routes: typeof routes
  scrollbarContentRef: React.MutableRefObject<undefined>
}

export const FirstLoginFlowNavLayer: FC<Props> = ({ routes, scrollbarContentRef, children }) => {
  const location = useLocation()
  const isFirstLoginFlowRoute = !isNil(firstLoginFlowRoutes.find(r => r.path === location.pathname))
  const hasState = !isNil(location.state)
  const isMainFirstLoginFlowRoute = location.pathname === FIRST_LOGIN_FLOW_PATHS.FIRST_LOGIN_FLOW
  const user = useSelector((state: RootStateOrAny) => state.user)
  const { availableOrganizations } = useGlobalQueries()
  const shouldDisplayFirstLoginFlow = !isNil(user.contact) &&
    isNil(user.contact.whatAreYouLookingFor) && !isNil(availableOrganizations) &&
    availableOrganizations?.length === 0
  const shouldDisplayMainApp = !isNil(user.contact?.whatAreYouLookingFor) || user.contact === null || availableOrganizations?.length > 0

  if (!shouldDisplayFirstLoginFlow && !shouldDisplayMainApp) {
    return <Loading atCenter />
  }

  if (shouldDisplayMainApp && !isFirstLoginFlowRoute) {
    return (children as JSX.Element)
  }

  if (shouldDisplayMainApp && isFirstLoginFlowRoute) {
    return <Redirect to={{ pathname: '/' }} />
  }

  if (!isFirstLoginFlowRoute) {
    return <Redirect to={{ pathname: FIRST_LOGIN_FLOW_PATHS.FIRST_LOGIN_FLOW }} />
  }

  if (isMainFirstLoginFlowRoute) {
    return <FirstLoginFlow />
  }

  if (isFirstLoginFlowRoute && !hasState) {
    return <Redirect to={{ pathname: FIRST_LOGIN_FLOW_PATHS.FIRST_LOGIN_FLOW }} />
  }

  if (isFirstLoginFlowRoute && hasState) {
    return (
      <div>
        {renderRoutes(routes, {
          scrollbarContentRef
        })}
      </div>
    )
  }

  return <Loading atCenter />
}
